const getFormatoFecha = (fecha, idioma) => {
  if (!fecha || fecha === "null") {
    return "";
  } else {
    let nueva = new Date(fecha);
    var newDate = new Date(nueva.getTime() + 10 * 60 * 60 * 1000);

    let opciones = { day: "2-digit", month: "short", year: "numeric" };
    let resultado = newDate.toLocaleDateString(
      idioma ? idioma : "es-MX",
      opciones
    );
    return resultado
      .replace(/\sde\s/g, " ")
      .replace(/\s/g, "/")
      .replace(/,/g, "");
  }
};

const getFormatoFechaExacta = (fecha, idioma) => {
  if (!fecha || fecha === "null") {
    return "";
  } else {
    let newDate = new Date(fecha);

    let opciones = { day: "2-digit", month: "short", year: "numeric" };
    let resultado = newDate.toLocaleDateString(
      idioma ? idioma : "es-MX",
      opciones
    );
    return resultado
      .replace(/\sde\s/g, " ")
      .replace(/\s/g, "/")
      .replace(/,/g, "");
  }
};

module.exports = {
  getFormatoFecha,
  getFormatoFechaExacta,
};
